$(function () {
	$(".key-item").each(function (index) {
		let _this = $(this);
		_this.mouseenter(function () {
			$(".key-background-item").eq(index).addClass("show");
		});
		_this.mouseleave(function () {
			$(".key-background-item").eq(index).removeClass("show");
		});
	});

	$(".key-item").each(function (index, element) {
		$(element)
			.find(".key-item-content")
			.css({
				"--content-height":
					$(element).find(".key-item-content-inner").outerHeight() +
					"px",
			});
	});
	$(window).resize(function () {
		$(".key-item").each(function (index, element) {
			$(element)
				.find(".key-item-content")
				.css({
					"--content-height":
						$(element)
							.find(".key-item-content-inner")
							.outerHeight() + "px",
				});
		});
	});

	$(".home-section-6 .item").each(function (index) {
		let _this = $(this);
		_this.mouseenter(function () {
			$(".home-section-6 .background-item").removeClass("show");
			$(".home-section-6 .background-item").eq(index).addClass("show");
		});
	});

	$(".home-section-8 .item").each(function (index, element) {
		$(element).on("mouseenter", function () {
			$(".home-section-8 .item").removeClass("active");
			$(this).addClass("active");
			$(".home-section-8 .img-hover img").attr(
				"src",
				$(this).find(".img-wrap img").attr("data-src")
			);
		});
	});
	$(".home-section-8 .item").eq(0).trigger("mouseenter");
});
